<div class="main-header">
    <div class="title"
         [ngClass]="state | async">
        {{title | async}}
    </div>
</div>
